export const SUBMIT_QUERY = "/contact-us";